export const dataCAR = [
  {
    id: 1,
    imgUrl: "11.png",
    alt: "siceen21",
    url: "https://sicee.ine.mx/home",
    itemActive: "",
  },
  {
    id: 2,
    imgUrl: "apoyo_ciudadano.png",
    alt: "Apoyo ciudadano",
    url: "https://itetlax.org.mx/assets/img/imgC_AR/apoyo_ciudadano.png",
    itemActive: "",
  },
  {
    id: 3,
    imgUrl: "0.png",
    alt: "Convocatoria OPPMT",
    url: "https://www.observatoriomujerestlaxcala.mx/contents/",
    itemActive: "",
  },
  {
    id: 4,
    imgUrl: "RedMujeres.webp",
    alt: "Red Mujeres (formulario)",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdZb2vkV6LQwamOR7zY3XC_gIHwkq-qbuQoAiWm6rQWQx6Ktg/viewform",
    itemActive: "",
  },
  {
    id: 5,
    imgUrl: "cddlm.jpg",
    alt: "Cartilla de derechos de las mujeres",
    url: "https://www.cartilladerechosdelasmujeres.gob.mx",
    itemActive: "",
  },
  {
    id: 6,
    imgUrl: "baner2_convocatoria_consulta.webp",
    alt: "",
    url: "https://www.iepcgro.mx/principal/sitio/sistemas_normativos_internos#acordeonEtapas",
    itemActive: "",
  },
  {
    id: 7,
    imgUrl: "banner_ieem.jpg",
    alt: "",
    url: "https://itetlax.org.mx/assets/pdf/agenda/Convocatoria_XXIX.pdf",
    itemActive: "",
  },
  {
    id: 8,
    imgUrl: "banner_ine_m.jpg",
    alt: "",
    url: "https://forms.office.com/pages/responsepage.aspx?id=s_aEj274YUiwaktieD60P_Clt1eTfM9LntsvJCK-tH5UMUM5MEFMVVZaTkNQQjI1MTZFUThUN0VKVC4u&route=shorturl",
    itemActive: "",
  },
  {
    id: 9,
    imgUrl: "conteos-censales.png",
    alt: "",
    url: "https://sicee.ine.mx/home",
    itemActive: "",
  },
  {
    id: 10,
    imgUrl: "BANNER-CONVOCATORIA-02.png",
    alt: "",
    url: "https://itetlax.org.mx/assets/pdf/convocatoria/PNIPPM_2026.pdf",
    itemActive: "",
  },
  {
    id: 11,
    imgUrl: "CARTEL_TEI_2026.png",
    alt: "",
    url: "https://www.te.gob.mx/TribunalElectoralInfantil//",
    itemActive: "",
  },
   {
    id: 12,
    imgUrl: "INFOGRAFIA_XXVII_CEP.jpg",
    alt: "",
    url: "https://itetlax.org.mx/assets/pdf/agenda/CONVOCATORIA_CEP_XXVII.pdf",
    itemActive: "",
  },
  {
    id: 13,
    imgUrl: "BANNER-CONVOCATORIA.png",
    alt: "",
    url: "https://www.ine.mx",
    itemActive: "active",
  },
];

